<template>
    <div class="no__print">
        <q-header reveal class="bg-white text-black" style="border-bottom: 1px solid #e0e0e0">
            <q-toolbar style="justify-content: space-between; padding: 0 2vw">
                <div style="height: 7.17vmin; display: flex; align-items: center">
                    <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                    <div class="header_lesson q-px-sm b1"><b>수능모의평가 분석리포트</b></div>
                </div>
<!--                <div v-if="gStore?.platform === 'DESKTOP'">
                    <q-icon name="img:/assets/images/icon/ico_report_print.svg" :onclick="onPrint" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                </div>-->
            </q-toolbar>
        </q-header>
        <q-page-container style="height: 100vh">
            <q-scroll-area visible style="height: 100%">
                <q-page>
                    <ReportContent v-if="reportData" :reportData="reportData" />
                </q-page>
            </q-scroll-area>
        </q-page-container>
    </div>
    <div class="print_area">
        <PrintReportContent v-if="reportData" :reportData="reportData" />
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import _ from 'lodash';
import { StudyStore } from '@/store/modules/study';
import { useRouter, useRoute } from 'vue-router';
import { DialogStore } from '@/store/modules/dialog';
import ReportContent from './reportContent.vue';
import PrintReportContent from './printReportContent.vue';
import { getReportSat } from '@/api/modules/study';
import { GlobalStore } from '@/store';
import { monitoringLog } from '@/api/modules/monitoring';

const gStore = GlobalStore();

const studyStore = StudyStore();

const router = useRouter();
const route = useRoute();
const store = DialogStore();
const reportData = ref(null);
const isPrintmode = ref(false);

const beforePrint = () => {
    isPrintmode.value = true;
};
const afterPrint = () => {
    isPrintmode.value = false;
};

window.onbeforeprint = beforePrint;

window.onafterprint = afterPrint;

const onPrint = () => {
    // isPrintmode.value = true;
    isPrintmode.value = true;
    setTimeout(() => {
        window.print();
    }, 500);
};

onMounted(() => {
    console.log('onMounted satReport');
    //
    // getReportSat({ learningHistorySeq: 3187, studentSeq: 178 }, (rs) => {
    if (studyStore.report?.learningHistorySeq) {
        getReportSat({ learningHistorySeq: studyStore.report?.learningHistorySeq }, (rs) => {
            reportData.value = rs;
        });
    }

    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('satReport monitoringLog API response ===', res);
    });
});

const movePg = (pg) => {
    router.push('/' + pg);
};

const checkConfirm = (val) => {
    val && router.push('/learninghome');
};

const onClickHome = () => {
    store.openConfirmDialog({
        message: '홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: checkConfirm,
    });
};
</script>

<style scoped lang="scss">
.print_area {
    visibility: hidden;
    position: absolute;
    right: 0;
}

.no__print {
    // visibility: visible;
    // display: block;
    visibility: visible;
    display: block;
}

@media print {
    .no__print {
        visibility: hidden;
        display: none;
    }

    .print_area {
        visibility: visible;
        display: contents;
        margin-bottom: 10px;
    }
}

::v-deep {
    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}
</style>
